module.exports = __webpack_public_path__ + "img/highlight4.ffa55eb9.png";